import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import titleBg from 'assets/images/bg/titleBg.png';

const footerStyles = {
    footertxt: css`
        text-align: center;
        margin-bottom: 20px;
        color: #808080;
    `,
    wrap: css`
        background: #fff;
        padding: 30px 0;
    `,
    heading: css`
        text-align: center;
        color: #8b95b3;
        font-weight: 500;
        padding: 24px;
        color: #000;
        font-weight: bold;
        text-transform: uppercase;
    `,
    partnerList: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    `,
    partnerItem: css`
        flex: 0 0 calc(100% / 7);
        max-width: calc(100% / 7);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 3%;
        img {
            width: 100%;
            object-fit: contain;
        }
    `,
    community: css`
        padding-top: 8px;
        padding-bottom: 28px;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #2b2f4b;
    `,
    titleComunity: css`
        padding: 16px 0;
    `,
    communityList: css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
    `,
    communityItem: css`
        background: #1a202c;
        border-radius: 4px;
        padding: 8px 12px;
        color: ${colors.white};
        img {
            width: 24px;
            margin-right: 16px;
        }
        p {
            font-size: 10px;
            color: #8b95b3;
        }
        h6 {
            font-size: 14px;
            font-weight: 500;
            margin-top: 4px;
        }
    `,
    cer: css`
        text-align: center;
        padding: 16px 0;
        border-bottom: 1px solid #2b2f4b;
    `,
    cerDes: css`
        color: #8b95b3;
        font-size: 14px;
        width: 70%;
        margin: 0 auto;
        text-align: center;
        font-weight: 300;
        padding: 10px 0 20px;
    `,
    lisence: css`
        text-align: center;
        color: #222939;
        /* background: #141928; */
        padding: 12px 0;
        font-size: 14px;
    `,
    about: css`
        margin: 24px 0;
        display: flex;
        justify-content: center;
        border-radius: 8px;
        color: #222939;
    `,
    title: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        margin-top: 30px;
        .title-game {   
            background: url(${titleBg}) no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            padding: 10px 230px;
            h6 {
                font-size: 22px;
                font-weight: 600;
                color: #fff;
            }
        }
    `,
    aboutItem: css`
        padding: 0 25px;
        font-weight: 600;
        transition: 0.25s;
        cursor: pointer;
        border-right: 1px solid #222939;
        text-align: center;
        &:last-child {
            border-right: 0;
        }
        &:hover {
            color: #fdcb44;
        }
    `,
};
export default footerStyles;
